import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { InombraRoutes } from 'src/app/models/routes';
import { UploadSources } from '../../../file-manager/models';
import { FileHttpService } from 'src/app/shared/services/http/file-http.service';
import { CommonModule } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MiddleClickDirective } from 'src/app/shared/directives/middle-click.directive';
import { RouterModule } from '@angular/router';
import { FileManagerService } from '../../../file-manager/services/file-manager.service';

@Component({
  selector: 'app-calendar-event-icons',
  templateUrl: './event-icons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    NzIconModule,
    NzToolTipModule,
    MiddleClickDirective,
    RouterModule,
  ],
})
export class EventIconsComponent {
  readonly fileHttp = inject(FileHttpService);
  readonly fileUtilitiesService = inject(FileManagerService);
  readonly InombraRoutes = InombraRoutes;
  readonly UploadSources = UploadSources;
  @Input('event') event;

  openAttachments(event): void {
    const id = event.type === 'custom' ? event.Id : event.ProjectId;
    const source =
      event.type === 'custom'
        ? this.UploadSources.calendar
        : this.UploadSources[event.type];

    this.fileHttp
      .searchFiles({
        sources: [source],
        source_ids: [id],
      })
      .subscribe(res => {
        this.fileUtilitiesService.openAttachments({ files: res.files });
      });
  }
}
